<template>
  <div class="handleRoles">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      :before-close="handleClose"
    >
      <div class="form_box">
        <el-form
          ref="formInline"
          :model="formInline"
          :rules="rules"
          label-width="100px"
        >
          <el-form-item label="角色名称" prop="roleName">
            <el-input
              v-model="formInline.roleName"
              placeholder="请填写角色名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="formInline.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" prop="roleDesc">
            <el-input
              type="textarea"
              maxlength="30"
              show-word-limit
              v-model="formInline.roleDesc"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleAffirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addProxyRole, addSubProxyRole, updateRole } from "@/api/organization";
export default {
  data() {
    return {
      dialogTitle: "",
      dialogVisible: false,
      formInline: {
        roleName: "",
        status: 1,
        roleDesc: "",
      },
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        roleDesc: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      status: "",
      type: "",
    };
  },
  methods: {
    // 初始化
    init(status, type, payload) {
      this.status = status;
      this.type = type;
      this.initData(payload);
      this.dialogTitle = status === "add" ? "新增角色" : "编辑角色";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.formInline.clearValidate();
      });
    },
    // 初始化数据
    initData(payload) {
      if (this.status === "add") {
        this.formInline = this.$options.data().formInline;
      } else if (this.status === "alter") {
        this.formInline = {
          roleId: payload.roleId,
          roleName: payload.roleName,
          status: payload.status,
          roleDesc: payload.roleDesc,
          roleCode: payload.roleCode,
        };
      }
    },
    // 取消
    handleClose() {
      this.dialogVisible = false;
    },
    // 确认
    handleAffirm() {
      this.$refs["formInline"].validate((valid) => {
        if (valid) {
          if (this.status === "add") {
            if (this.type === "agency") {
              addProxyRole({ ...this.formInline }).then((res) => {
                if (res.code === 0) {
                  this.$parent.refresh();
                  this.$message({
                    message: "添加成功",
                    type: "success",
                  });
                  this.dialogVisible = false;
                }
              });
            } else if (this.type === "distribution") {
              addSubProxyRole({ ...this.formInline }).then((res) => {
                if (res.code === 0) {
                  this.$parent.refresh();
                  this.$message({
                    message: "添加成功",
                    type: "success",
                  });
                  this.dialogVisible = false;
                }
              });
            }
          } else if (this.status === "alter") {
            updateRole({ ...this.formInline }).then((res) => {
              if (res.code === 0) {
                this.$parent.refresh();
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.dialogVisible = false;
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.handleRoles {
}
</style>